import script from "./CertificationDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificationDetails.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/certifications-and-disbursements.css?vue&type=style&index=0&id=f72aff50&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f72aff50"]])

export default __exports__